import './forkscorks2/style';
import FormStructure from './forkscorks2/form_structure';

export default FormStructure;